import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Country } from '../models/country.model';
import { ConfigService } from 'src/app/core/config/config-service';

@Injectable({ providedIn: 'root' })
export class CountryService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.configService.getUrlVendorCatalogApi()}/countries`;
  }

  /**
   * Lädt alle Länder vom Backend.
   */
  fetchCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(this.baseUrl);
  }

  /**
   * Lädt ein einzelnes Land anhand der ID.
   */
  getCountryById(id: number): Observable<Country> {
    return this.http.get<Country>(`${this.baseUrl}/${id}`);
  }
}